<div>
	@if (!previewMode) {
		<text-area [htmlPrefix]="htmlPrefix()" [placeholder]="isComment ? 'Add additional comment here' : 'Please translate to english'" [label]="isComment ? 'Translation comments' : null"
				   [autoGrowEnabled]="true" [form]="getForm()"
				   [controlName]="getControlName()" [formService]="formService" [dataTestId]="htmlPrefix()"></text-area>
	} @else {
		<div class="translation-preview">
			@if (isComment && previewMode) {
				<label>Translation comments</label>
			}
			<span>{{ translatedText }}</span>
		</div>
	}

</div>
